import type { GlobalLocales } from '../types';

const global: GlobalLocales = {
  account: 'Account',
  accountSettings: 'Account Settings',
  archive: 'Archive',
  assigned: 'Assigned',
  assignments: 'Assignments',
  availability: 'Availability',
  available: 'Available',
  blocked: 'Blocked',
  cancel: 'Cancel',
  checkProfile: 'Check Profile',
  clear: 'Clear',
  clickHere: 'Click here',
  close: 'Close',
  competence: 'Competence',
  confirm: 'Confirm',
  confirmAction: 'Confirm action',
  continue: 'Continue',
  dashboard: 'Dashboard',
  date: 'Date',
  details: 'Details',
  disabled: 'Disabled',
  done: 'Done',
  email: 'Email',
  emailInvalidErrorMessage: 'Email is invalide!',
  endTime: 'End time',
  error: 'Error',
  export: 'Export',
  favorites: 'Favorites',
  fieldMustBePositiveMessage: 'This field must be positive',
  fieldRequiredErrorMessage: 'This field is required',
  freelancer: 'Freelancer',
  freelancers: 'Freelancers',
  goBack: 'Go Back',
  help: 'Help',
  home: 'Home',
  hourlyRate: 'Hourly rate',
  hourlyRates: 'Hourly Rates',
  instructions: 'Instructies',
  integrations: 'Integrations',
  interest: 'Interest',
  invoices: 'Invoices',
  loading: 'Loading',
  location: 'Location',
  locations: 'Locations',
  login: 'Login',
  logout: 'Logout',
  maxLengthFieldError: {
    other: 'Max length: %{count}',
  },
  minLengthFieldError: {
    other: 'Min length: %{count}',
  },
  minLengthPasswordErrorMessage: 'password is too short!',
  minute: {
    one: '1 minute',
    other: '%{count} minutes',
    zero: '0 minute',
  },
  mode: 'Mode',
  mustAgree: 'You have to agree to terms and conditions!',
  navigateToDashboard: 'Navigate to dashboard page',
  navigateToHomePage: 'Navigate to home page',
  navigateToOrganisationSettingsPage: 'Navigate to Settings page',
  navigateToPlannerPage: 'Navigate to planner page',
  NB: 'NB!',
  next: 'Next',
  nextStep: 'next step',
  no: 'No',
  noResultsFound: 'We were unable to find any results for you.',
  noResultsFoundShort: 'No results found.',
  notification: 'Notification',
  notifications: 'Notifications',
  numberTypeError: 'This field must be a number',
  open: 'Open',
  organisation: 'Organisation',
  organisationSettings: 'Organisation Settings',
  pageDidntLoad: "Page didn't load ",
  password: 'Password',
  passwordConfirmation: 'Password Confirmation',
  PasswordConstraintErrorMessage: 'Password must contain letters and numbers!',
  passwordsMustMatchErrorMessage: 'Passwords must match!',
  pause: 'Pause',
  periodJobs: 'Period jobs',
  personal: 'Personal',
  phoneNumberInvalidErrorMessage:
    'Enter a valid phone number. for example: 0612345678',
  placeACall: 'Place a call',
  planner: 'Planner',
  planners: 'Planners',
  postalCodeInvalidErrorMessage: 'Enter a valid Postal Code',
  previous: 'Previous',
  readInstructions: 'Read instructions',
  readInstructionsTooltip:
    'Click here to read instructions for a particular step',
  ReloadPage: 'Reload page',
  retry: 'Retry',
  save: 'Save',
  saveAndContinue: 'save and continue',
  settings: 'Settings',
  signUp: 'Sign up',
  skipStep: 'skip step',
  somethingWentWrong: 'Something went wrong',
  sorryPageDidntLoadTryAgain: "Sorry page didn't load. Try again",
  staff: 'Staff',
  start: 'Start',
  startTime: 'Start time',
  termsAndConditions: 'Terms and conditions',
  time: 'Time',
  toAsk: 'To ask',
  toCallToAction: 'To call to action',
  toInvite: 'To invite',
  unknownError: 'Unknown error happened, please try again later.',
  urgent: 'Urgent',
  userName: 'Username',
  users: 'Users',
  vacancies: 'Vacancies',
  watchVideoInstructions: 'Watch instruction video',
  watchVideoInstructionsTooltip: 'Click here to go back to the video',
  yes: 'Yes',
};

export default global;
